module.exports = __webpack_public_path__ + "static/media/func.9574037c.png";